import ColorsStyles from '@Styles/colors.scss';
import { stopBubbling } from '@Utils/helpers/eventHelpers';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Popover } from '@mui/material';
import React from 'react';
import Styles from './PopoverMenu.scss';

interface IPopoverMenuProps {
    children: any;
    btnContainerStyle?: any;
    isHidden?: boolean;
    onClose?: any;
    onOpen?: any;
    iconColour?: string;
    backgroundColour?: string;
    id?: string;
}

interface IPopoverMenuState {
    isOpen: boolean;
    id: string;
}

class PopoverMenu extends React.Component<
    IPopoverMenuProps,
    IPopoverMenuState
> {
    id: string;
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            id: Math.random().toString(16),
        };
        this.toggleView = this.toggleView.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
    }

    toggleView(e) {
        stopBubbling(e);
        this.setState({ isOpen: !this.state.isOpen }, () => {
            if (this.state.isOpen && this.props.onOpen) {
                this.props.onOpen();
            }
        });
    }

    closeMenu(e) {
        stopBubbling(e);
        this.setState({ isOpen: false }, () => {
            if (this.props.onClose) {
                this.props.onClose();
            }
        });
    }

    render() {
        if (this.props.isHidden && !this.state.isOpen) {
            return null;
        }

        const iconColour = this.props.iconColour
            ? this.props.iconColour
            : '#000';

        return (
            <React.Fragment>
                <div
                    className={Styles.popoverMenuBtnContainer}
                    style={this.props.btnContainerStyle}
                >
                    <button
                        className={Styles.popoverMenuBtn}
                        onClick={(e) => this.toggleView(e)}
                        id={this.state.id}
                    >
                        <MoreVertIcon
                            className={Styles.popoverMenuBtnIcon}
                            style={{
                                color: iconColour,
                            }}
                        />
                    </button>
                </div>

                <Popover
                    id={`${this.state.id}-menu`}
                    open={this.state.isOpen}
                    anchorEl={document.getElementById(this.state.id)}
                    onClose={this.closeMenu}
                    PaperProps={{
                        sx: {
                            borderRadius: 0,
                            backgroundColor: 'transparent',
                            dropShadow: 'none',
                            boxShadow: 'none',
                            border: `${ColorsStyles.ikeGradient11} solid 1px`,
                        },
                    }}
                    anchorOrigin={{
                        horizontal: 5,
                        vertical: -6,
                    }}
                >
                    <div
                        className={Styles.popoverMenuContent}
                        onClick={this.closeMenu}
                    >
                        <div className={Styles.popoverMenuPadder}>
                            <MoreVertIcon
                                className={Styles.popoverMenuBtnIcon}
                                style={{
                                    color: iconColour,
                                }}
                            />
                        </div>

                        <div className={Styles.popoverMenuChildrenContainer}>
                            {this.props.children}
                        </div>
                    </div>
                </Popover>
            </React.Fragment>
        );
    }
}

export default PopoverMenu;
